// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Switch_checkbox__iKNzf","label":"Switch_label__yQfws","isLoading":"Switch_isLoading__7b0QI","spin":"Switch_spin__B_wBT","wrapper":"Switch_wrapper__wnqc5"};